import constants from './constants';

export function error(reason, message, title) {
  return {
    type: constants.actions.ERROR,
    reason,
    message,
    title,
  };
}

export default {
  error,
};
